import { OptionDropdown } from "@/components/OptionDropdown";
import { ReviewDatePicker } from "@/containers/Project/components/Schedules/components/Buttons/ReviewDatePicker";
import { formattedDateValue } from "@/containers/Project/helper";
import { MenuItemType } from "@/enums";
import { generateMenuItems } from "@/helpers/generateMenuItems";
import { arrayOf, bool, func, string } from "prop-types";
import { useState } from "react";
import { useIntl } from "react-intl";

export const ScheduleHistoryDateSelector = ({
  scheduleId,
  selectedDate,
  baselineOptions,
  updateAsOfDate,
  loading,
  hasPastReviewDate,
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const intl = useIntl();

  const toggleDropdownOpen = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleChange = (index) => {
    setDropdownOpen(false);
    updateAsOfDate(baselineOptions.at(index));
  };

  const handleCustomChange = (date) => {
    setDropdownOpen(false);
    updateAsOfDate(date);
  };

  const getCurrentTitle = () => {
    if (selectedDate) {
      return formattedDateValue(selectedDate);
    }

    if (!hasPastReviewDate) {
      return intl.formatMessage({ id: "projectMilestoneTable.select" });
    }

    return intl.formatMessage({ id: "projectMilestoneTable.review" });
  };

  const handleMenuActions = (e) => {
    if (e.key.includes("date-history-option")) {
      // Get index from last segment of key
      const keyArray = e.key.split("-");
      const index = keyArray[keyArray.length - 1];

      handleChange(index);
    }
  };

  const getMenuItems = () => {
    const menuItems = [];

    menuItems.push({
      title: intl.formatMessage({
        id: "projectMilestoneTable.reviewLabel",
      }),
      key: "review-label",
      type: MenuItemType.Group,
      visible: baselineOptions?.length > 0,
    });

    baselineOptions?.forEach((option, index) => {
      menuItems.push({
        title: formattedDateValue(option),
        key: `date-history-option-${index}`,
        type: MenuItemType.Item,
      });
    });

    menuItems.push({
      key: "baseline-date-picker",
      type: MenuItemType.CustomItem,
      customHtml: (
        <ReviewDatePicker
          handleChange={(date) => handleCustomChange(date)}
          scheduleId={scheduleId}
        />
      ),
    });

    return menuItems;
  };

  return (
    <OptionDropdown
      items={generateMenuItems(getMenuItems())}
      title={getCurrentTitle()}
      id={scheduleId}
      loading={loading}
      open={dropdownOpen}
      handleClick={toggleDropdownOpen}
      handleMenuClick={handleMenuActions}
    />
  );
};

ScheduleHistoryDateSelector.propTypes = {
  scheduleId: string,
  selectedDate: string,
  updateAsOfDate: func,
  baselineOptions: arrayOf(string),
  loading: bool,
  hasPastReviewDate: bool,
};
